import ButtonMore from './src/index.vue'

ButtonMore.install = Vue => {
  Vue.component(ButtonMore.name, ButtonMore)
}

export default ButtonMore
